module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
    var alignPosition = 'top';
    if (!u.isTrue(buttonPositionAbove)) {
        alignPosition = 'bottom';
    }

    ; __append("\r\n")
    ;  
        let localizedButtonSave = u.getLocalizedText(id, 'buttonLabelSave') || buttonLabelSave;
        let localizedButtonClear = u.getLocalizedText(id, 'buttonLabelClear') || buttonLabelClear;  

    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control pf-selectable has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    \r\n    <div class=\"pf-control-core\" style=\"width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) + (u.extractNum(buttonFontSize)/2) ))
    ; __append("px; overflow:auto\">\r\n        ")
    ;  if( alignPosition === 'bottom') { 
    ; __append("\r\n         <div style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) -15 - u.extractNum(buttonFontSize) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width) - 2 ))
    ; __append("px;\r\n                 border: 1px solid #000000;\r\n                 background:")
    ; __append(escapeFn(imageBackgroundColor))
    ; __append(";\">\r\n\r\n         </div>\r\n         <div  style=\"background:transparent; margin-top: 3px\">\r\n            <div style=\"white-space: nowrap;\">\r\n              <input type=\"button\" value=\"")
    ; __append(escapeFn(localizedButtonSave))
    ; __append("\" style=\"\r\n                      border: 1px solid ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                      border-radius: 2px;\r\n                      font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("'; font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                      font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                      color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                      background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                      background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                      background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                      background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\r\n                      width: 60px;\"/>\r\n              <input type=\"button\" value=\"")
    ; __append(escapeFn(localizedButtonClear))
    ; __append("\" style=\"\r\n                      border: 1px solid ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                      border-radius: 2px;\r\n                      font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("'; font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                      font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                      color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                      background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                      background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                      background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                      background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\r\n                      width: 60px;\"/>\r\n            </div>\r\n         </div>\r\n        ")
    ;  }
        else{
        
    ; __append("\r\n        <div  style=\"background:transparent;\">\r\n            <div>\r\n                <input type=\"button\" value=\"")
    ; __append(escapeFn(buttonLabelSave))
    ; __append("\" style=\"\r\n                        border: 1px solid ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                        border-radius: 2px;\r\n                        font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("'; font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                        font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                        color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                        background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                        background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                        background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                        background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\"/>\r\n                <input type=\"button\" value=\"")
    ; __append(escapeFn(buttonLabelClear))
    ; __append("\" style=\"\r\n                        border: 1px solid ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                        border-radius: 2px;\r\n                        font-family: '")
    ; __append(escapeFn(buttonFontFamily))
    ; __append("'; font-size: ")
    ; __append(escapeFn(buttonFontSize))
    ; __append("px;\r\n                        font-style: ")
    ; __append(escapeFn(buttonTextStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(buttonTextWeight))
    ; __append(";\r\n                        color: ")
    ; __append(escapeFn(buttonTextColor))
    ; __append(";\r\n                        background: ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(";\r\n                        background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                        background: -webkit-linear-gradient(0% 0%, 0% 100%, from(")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append("), to(")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append("));\r\n                        background: -moz-linear-gradient(center top,  ")
    ; __append(escapeFn(buttonBackgroundColor))
    ; __append(", ")
    ; __append(escapeFn(buttonBackgroundGradientColor))
    ; __append(");\"/>\r\n            </div>\r\n        </div>\r\n        <div style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) -25 ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                border: 1px solid #000000;\r\n                background:")
    ; __append(escapeFn(imageBackgroundColor))
    ; __append(";\">\r\n\r\n        </div> \r\n        ")
    ; }
    ; __append("\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>")
  }
  return __output;

}